import { Link } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Footer } from '@/components/Footer';
import { Navbar } from '@/components/Navbar';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen gradient-surface gradient-mesh flex flex-col">
      <Navbar />
      
      <main className="flex-1 container mx-auto px-4 py-8 max-w-4xl">
        <div className="glass-strong rounded-3xl p-6 lg:p-10 glow-border">
          <div className="flex items-center gap-4 mb-8">
            <Link to="/">
              <Button variant="ghost" size="icon" className="rounded-full">
                <ArrowLeft className="w-5 h-5" />
              </Button>
            </Link>
            <div className="w-12 h-12 rounded-2xl gradient-bg flex items-center justify-center">
              <Shield className="w-6 h-6 text-primary-foreground" />
            </div>
            <h1 className="text-3xl font-bold">Privacy Policy</h1>
          </div>

          <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6">
            <p className="text-muted-foreground">Last updated: December 30, 2024</p>

            <section>
              <h2 className="text-xl font-semibold mb-3">1. Introduction</h2>
              <p className="text-muted-foreground leading-relaxed">
                Welcome to TempVault. We respect your privacy and are committed to protecting your personal data. 
                This privacy policy explains how we handle information when you use our disposable email service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. What We Collect</h2>
              <p className="text-muted-foreground leading-relaxed">
                TempVault is designed with privacy in mind. We collect minimal data:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 mt-3">
                <li>Temporary email addresses generated for you</li>
                <li>Emails received at your temporary address (automatically deleted after 24 hours)</li>
                <li>Basic usage analytics (non-personally identifiable)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. Data Retention</h2>
              <p className="text-muted-foreground leading-relaxed">
                All emails and inbox data are automatically deleted after 24 hours. We do not store any 
                personal information beyond this period. Our system is designed to be ephemeral by nature.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. Third-Party Services</h2>
              <p className="text-muted-foreground leading-relaxed">
                We use third-party advertising services to support our free service. These services may use 
                cookies and similar technologies to serve relevant ads. You can manage your cookie preferences 
                through your browser settings.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Security</h2>
              <p className="text-muted-foreground leading-relaxed">
                We implement industry-standard security measures to protect your data. All communications 
                are encrypted, and we regularly update our security practices to ensure your information 
                remains protected.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Contact Us</h2>
              <p className="text-muted-foreground leading-relaxed">
                If you have any questions about this Privacy Policy, please contact us through our{' '}
                <Link to="/contact" className="text-primary hover:underline">Contact page</Link>.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
